import React, { useEffect, useMemo, useState } from "react";
import TableContainer from "../../components/Common/TableContainer";
import Breadcrumb from "../../components/Common/Breadcrumb";
import { Card, CardBody, Button, Container } from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import {
  formatDate,
  getRecords,
  uploadExelFile,
} from "../../services/api.service";
import { exportPageData } from "./OrderFile";
import moment from "moment";
import ModernPopup from "../../services/popup/Popup";

const breadcrumbItems = [];

const OrdertList = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [exportData, setExportData] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [popupData, setPopupData] = useState({
    isOpen: false,
    message: "",
    isError: false,
  });

  useEffect(() => {
    getData();
  }, [searchKeyword, page, pageSize, selectedFile]);

  useEffect(() => {
    const projectId = JSON.parse(localStorage?.getItem("projectID"));
    handleExportData(projectId);
  }, []);

  const getData = async () => {
    const projectId = JSON.parse(localStorage?.getItem("projectID"));
    try {
      const payload = {
        modelName: "orders",
        whereCondition: {
          project_id: projectId,
        },
        relations: [
          {
            module: "projects",
            moduleAs: "project",
          },
          {
            module: "company_masters",
            moduleAs: "company",
          },
          {
            module: "order_documents",
            moduleAs: "order_documents",
          },
        ],
        search: {
          searchKeyword: searchKeyword,
          field_name: [
            "project.project_code",
            "order_no",
            "order_ref_no",
            "company.company_name",
            "project.project_name",
          ],
        },
        pagination: {
          page: page + 1,
          pageSize: pageSize,
        },
      };

      const responseData = await getRecords(payload, "/listOrder");

      // Assign an `index` property starting from 1
      responseData.data.forEach((element, index) => {
        element.index = index + 1;
      });
      setTotalCount(responseData.count);

      const sortedData = responseData.data.sort((a, b) => b.index - a.index);
      setData(sortedData);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleClickAdd = () => {
    navigate("/order-create");
  };

  const handleEditClick = (id) => {
    navigate(`/order-create/${id}`);
  };

  const handleViewClick = (id) => {
    navigate(`/order-view/${id}`);
  };

  const getSearchInputData = (inputValue) => {
    setSearchKeyword(inputValue);
  };

  const nextToPages = () => {
    setPage(page + 1);
  };

  const previousToPages = () => {
    setPage(page - 1);
  };

  const handlePageSizeChange = (data) => {
    setPageSize(data);
    const newTotalPages = Math.ceil(totalCount / data);
    if (page >= newTotalPages) {
      setPage(0);
    }
  };

  const lastToPages = () => {
    setPage(Math.ceil(totalCount / pageSize) - 1);
  };

  const previousFirstToPages = () => {
    setPage(0);
  };
  const columns = useMemo(
    () => [
      {
        Header: "SR.NO",
        accessor: "index",
        accessor: (row) => page * pageSize + row.index,
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => <div style={{ width: "50px" }}>{value}</div>,
      },

      {
        Header: "PROJECT",
        accessor: (row) =>
          row?.project && row?.project?.project_name
            ? row?.project?.project_name
            : "-",
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => <div style={{ width: "150px" }}>{value}</div>,
      },
      {
        Header: "PROJECT CODE",
        accessor: (row) =>
          row?.project && row?.project?.project_code
            ? row?.project?.project_code
            : "-",
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => <div style={{ width: "150px" }}>{value}</div>,
      },
      {
        Header: "SO No",
        accessor: (row) =>
          row?.order_no && row?.order_no ? row?.order_no : "-",
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => <div style={{ width: "150px" }}>{value}</div>,
      },
      {
        Header: "ORDER REFERENCE NO",
        accessor: (row) => (row && row?.order_ref_no ? row?.order_ref_no : "-"),
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => <div style={{ width: "150px" }}>{value}</div>,
      },
      {
        Header: "CUSTOMER",
        accessor: (row) =>
          row?.company && row?.company ? row?.company?.company_name : "-",
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => <div style={{ width: "150px" }}>{value}</div>,
      },
      {
        Header: "ORDER DATE",
        accessor: (row) =>
          row?.order_date ? formatDate(row?.order_date) : "-",
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => <div style={{ width: "100px" }}>{value}</div>,
      },
      {
        Header: "ORDER STATUS",
        accessor: (row) => (
          <span className="badge bg-success-subtle text-success text-uppercase">
            {row?.status?.split("_").join(" ")}
          </span>
        ),
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => <div style={{ width: "150px" }}>{value}</div>,
      },
      {
        Header: "STATUS",
        accessor: "is_active",
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => (
          <div style={{ width: "100px" }}>
            {value === "Active" || value === false || value === 0 ? (
              <span className="badge bg-danger-subtle text-danger text-uppercase">
                In-active
              </span>
            ) : (
              <span className="badge bg-success-subtle text-success text-uppercase">
                Active
              </span>
            )}
          </div>
        ),
      },

      {
        Header: "ACTION",
        accessor: "actions",
        disableFilters: true,
        filterable: false,
        Cell: ({ row }) => (
          <div
            style={{
              width: "150px",
              display: "flex",
            }}
          >
            {row?.original?.is_order_invoice_completed == false ? (
              <div
                onClick={() => {
                  handleEditClick(row.original.id);
                }}
              >
                <Link className="me-3 text-primary">
                  <i className="mdi mdi-pencil font-size-18"></i>
                </Link>
              </div>
            ) : (
              <div style={{ visibility: "hidden" }}>
                <Link className="me-3 text-primary">
                  <i className="mdi mdi-pencil font-size-18"></i>
                </Link>
              </div>
            )}
            <div
              onClick={() => {
                handleViewClick(row.original.id);
              }}
            >
              <Link className="me-3 text-primary">
                <i className="mdi mdi-eye font-size-18"></i>
              </Link>
            </div>
          </div>
        ),
      },
    ],
    [page, pageSize]
  );

  const handleExportData = async (projectId) => {
    try {
      exportPageData.data.whereCondition = {
        project_id: projectId,
      };

      const responseData = await getRecords(
        exportPageData?.data,
        "/getRecords"
      );
      if (responseData?.data?.length == 0) setExportData([]);
      const exportData = responseData?.data.map((item, index) => ({
        "SR. NO": index + 1,
        PROJECT: item?.project?.project_name || "-",
        "PROJECT CODE": item?.project?.project_code || "-",

        "SO No": item?.order_no || "-",
        "ORDER REFERENCE NO": item?.order_ref_no || "-",
        CUSTOMER: item?.company?.company_name || "-",
        "ORDER DATE": formatDate(item?.order_date) || "-",
        "ORDER STATUS": item?.status?.split("_").join(" ") || "-",
        STATUS:
          item?.is_active === false || item?.is_active === 0
            ? "In-active"
            : "Active",
      }));
      setExportData(exportData);
    } catch (error) {
      console.error("Error fetching records:", error);
    }
  };

  const handleFileUpload = async (e) => {
    try {
      const file = e.target.files[0];

      const fileExtension = file.name.split(".").pop().toLowerCase();

      if (fileExtension !== "xlsx" && fileExtension !== "xls") {
        throw new Error("Please select a valid Excel file.");
      }

      setIsLoading(false);
      const projectId = JSON.parse(localStorage?.getItem("projectID"));
      const userDetails = JSON.parse(localStorage.getItem("userDetails")) || {};
      const createdBy = userDetails.id || null;

      const res = await uploadExelFile(
        "uploads",
        file,
        `/importOrders?createdBy=${createdBy}&project_id=${projectId}`
      );
      setIsLoading(false);

      if (!res?.code && res?.message) {
        setPopupData({
          isOpen: true,
          message: res.message || "File imported successfully!",
          isError: false,
        });
        setSelectedFile(file);
      } else {
        setPopupData({
          isOpen: true,
          message: res?.message || "Error importing file. Please try again.",
          isError: true,
        });
      }
    } catch (error) {
      console.error("Upload error:", error);
      setIsLoading(false);

      const errorMessage =
        error?.message ||
        error?.Error ||
        "An error occurred while importing. Please try again.";

      setPopupData({
        isOpen: true,
        message: errorMessage,
        isError: true,
      });
    }

    setTimeout(() => {
      e.target.value = "";
    }, 0);
  };

  const closePopup = () => {
    setPopupData((prev) => ({ ...prev, isOpen: false }));
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <ModernPopup
          isOpen={popupData.isOpen}
          onClose={closePopup}
          message={popupData.message}
          isError={popupData.isError}
        />
        <Container fluid>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "10px",
            }}
          >
            <Breadcrumb title="Order List" breadcrumbItems={breadcrumbItems} />
            <Button
              color="primary"
              className="waves-effect waves-light me-1"
              onClick={handleClickAdd}
              style={{ marginLeft: "auto", background: "#006eb9" }}
            >
              Create Order
            </Button>
            {/* <Button
              color="success"
              className="waves-effect waves-light me-1"
              onClick={() => document.getElementById("fileInput").click()}>
              Import
            </Button>
            <input
              type="file"
              id="fileInput"
              style={{ display: "none" }}
              accept=".xlsx, .xls"
              onChange={(e) => handleFileUpload(e)}
            /> */}
          </div>

          <Card>
            <CardBody>
              <TableContainer
                columns={columns || []}
                data={data || []}
                isPagination={false}
                // isGlobalFilter={false}
                iscustomPageSize={false}
                isBordered={false}
                customPageSize={10}
                isLoading={isLoading}
                onSearchInputData={getSearchInputData}
                pageIndexProp={page}
                onPageSizeChange={handlePageSizeChange}
                nextToPage={nextToPages}
                lastToPage={lastToPages}
                previousToPage={previousToPages}
                previousFirstToPage={previousFirstToPages}
                totalCount={totalCount}
                exportData={exportData}
                exportFileName={exportPageData?.fileName}
              />
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default OrdertList;
